import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import NewClientPostScenarioOverviewCard from 'Views/Dashboard/NewClientPostScenarioOverviewCardPicker';
import DefaultDesktopDashboardTopSection from 'Views/Dashboard/DefaultDesktopDashboardTopSection';
import ActiveScenarioChartPicker from 'Views/Dashboard/ActiveScenarioChartPicker';
import HouseholdNextAction from 'Views/Dashboard/HouseholdNextAction';
import {
  RoadmapDeliverableDashboardChartContainer,
} from 'Views/Dashboard/RoadmapDeliverableDashboardChart/RoadmapDeliverableDashboardChartContainer';
import {
  RoadmapDeliverableReviewRoadmapContainer,
} from 'Views/Dashboard/RoadmapDeliverableDashboardChart/RoadmapDeliverableReviewRoadmapContainer';

const DashboardTopSectionDesktopPicker = props => {
  const { clientDashboardResource } = useDashboardContext();

  return pick(clientDashboardResource, {
    [fr.relationships.roadmapDeliverableChart.name]: <>
      <RoadmapDeliverableDashboardChartContainer />
      <RoadmapDeliverableReviewRoadmapContainer />
    </>,
    [fr.relationships.householdNextAction.name]: <HouseholdNextAction />, // If you have something to do in an activation test
    [fr.relationships.facetPlanMultiChartData.name]: <>
      <NewClientPostScenarioOverviewCard {...props} />
      <ActiveScenarioChartPicker {...props} />
    </>,
  }, <DefaultDesktopDashboardTopSection />);
};

export default DashboardTopSectionDesktopPicker;
